<template>
  <div class="career" :class="{'careerDark':isDark}">
    <div class="top">
        <div class="select">
            <p @click="showMatch=true">{{kind}} <van-icon name="arrow-down" /></p>
        </div>
        <div class="tab">
            <p :class="{'active' : tab == 1}" @click="clickInfo(1)">场均</p>
            <p :class="{'active' : tab == 2}" @click="clickInfo(2)">总数</p>
        </div>
    </div>
    <div class="teamData">
            <div class="table">
                <div class="tbody">
                    <div class="left">
                        <div class="item header">
                            <div class="competitionSeason">
                                赛季
                            </div>
                            <div class="sessions">
                                球队
                            </div>
                            <div class="sessions">
                                场次
                            </div>
                        </div>
                        <div class="item" v-for="(item, index) in data[kind]" :key="index">
                            <div class="competitionSeason">
                                {{item.season}}
                            </div>
                            <div class="sessions">
                                {{item.team_name}}
                            </div>
                            <div class="sessions">
                                {{item.sch}}
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="item header">
                            <div style="width: 80px">胜负</div>
                            <div>胜率</div>
                            <div>时间</div>
                            <div>篮板</div>
                            <div>助攻</div>
                            <div>抢断</div>
                            <div>盖帽</div>
                            <div>投篮</div>
                            <div>投篮%</div>
                            <div>三分</div>
                            <div>三分%</div>
                            <div>罚球</div>
                            <div>罚球%</div>
                            <div>犯规</div>
                        </div>
                        <div class="item" v-for="(item, index) in data[kind]" :key="index">
                            <div style="width: 80px">{{parseFloat(item.win)}}/{{parseFloat(item.fail)}}</div>
                            <div>{{parseFloat(item.win_per).toFixed(1)}}%</div>
                            <div>{{item.play_time == 0 ? 0 : item.play_time ? parseFloat(item.play_time / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.backboard == 0 ? 0 : item.backboard ? parseFloat(item.backboard / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.helpattack == 0 ? 0 : item.helpattack ? parseFloat(item.helpattack / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.rob == 0 ? 0 : item.rob ? parseFloat(item.rob / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.cover == 0 ? 0 : item.cover ? parseFloat(item.cover / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.shoot == 0 ? 0 : item.shoot ? parseFloat(item.shoot / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.shoot_hit_per == 0 ? 0 : item.shoot_hit_per ? parseFloat(item.shoot_hit_per / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}%</div>
                            <div>{{item.threemin == 0 ? 0 : item.threemin ? parseFloat(item.threemin / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.threemin_hit_per == 0 ? 0 : item.threemin_hit_per ? parseFloat(item.threemin_hit_per / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}%</div>
                            <div>{{item.punishball == 0 ? 0 : item.punishball ? parseFloat(item.punishball / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                            <div>{{item.punishball_hit_per == 0 ? 0 : item.punishball_hit_per ? parseFloat(item.punishball_hit_per / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}%</div>
                            <div>{{item.foul == 0 ? 0 : item.foul ? parseFloat(item.foul / (tab == 2 ? 1 : item.sch)).toFixed(1) : '-'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <van-popup
            v-model="showMatch"
            round
            position="bottom"
            :style="{ height: '40vh' }"
        >
            <van-picker
                show-toolbar
                :default-index="season_kind.indexOf(kind)"
                :columns="season_kind"
                @confirm="onConfirm"
                @cancel="showMatch = false"
            />
    </van-popup>
  </div>
</template>

<script>
import { getPlayerCareer } from "@/api/team.js"
export default {
    name: 'career',
    data () {
        return {
            tab: 1,
            showMatch: false,
            columns: ['2001', '2002'],
            player_id: this.$route.query.player_id || 18,
            data: null,
            season_kind: null,
            kind: null,
            num: 1
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getPlayerCareer()
    },
    methods: {
        clickInfo (num) {
            this.tab = num
        },
        async getPlayerCareer () {
            const params = {
                player_id: this.player_id
            }
            const res = await getPlayerCareer(params)
            if (res.errno === 0) {
                if (res.data) {
                    const obj = {}
                    res.data.forEach((item) => {
                        if (obj[item.season_kind]) {
                            obj[item.season_kind].push(item)
                        } else {
                            obj[item.season_kind] = [item]
                        }
                    });
                    this.data = obj
                    this.season_kind = Array.from(new Set(res.data.map(item => item.season_kind)))
                    this.kind = this.season_kind.indexOf('常规赛') > -1 ? this.season_kind[this.season_kind.indexOf('常规赛')] : this.season_kind[0]
                }
            } else {
                this.$toast(res.errmsg)
            }
        },
        onConfirm (value) {
            this.kind = value
            this.showMatch = false
        }
    }
}
</script>

<style lang="less" scoped>
.career {
    background: #FFFFFF;
    padding: 10px 12px;
    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .select {
            p {
                font-size: 11px;
                font-weight: 400;
                color: #666666;
            }
        }
        .tab {
            display: flex;
            p {
                width: 40px;
                height: 20px;
                // border: 1px solid #169AFF;
                font-size: 12px;
                font-weight: 400;
                color: #169AFF;
                line-height: 19px;
                text-align: center;
                &:first-child {
                    border-radius: 4px 0px 0px 4px;
                    border: 1px solid #169AFF;
                }
                &:last-child {
                    border-radius: 0px 4px 4px 0px;
                    border: 1px solid #169AFF;
                }
            }
            .active {
                background: #169AFF;
                color: #FFFFFF;
                border: none !important;
            }
        }
    }
    .teamData{
        margin-top: 5px;
        .table{
            .tbody{
                display: flex;
                .left{
                    width: 120px;
                    .item{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #f2f2f2;
                        height: 32px;
                        font-size: 11px;
                        font-weight: 400;
                        color: #333333;
                        div{
                            flex: 1;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        &:nth-child(even) {
                            background: #F5F5F5;
                        }
                    }
                    .header{
                        background: #FFFFFF;
                        box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.1);
                        font-size: 11px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
                .right{
                    flex: 1;
                    float: left;
                    overflow: auto;
                    .item{
                        width: 600px;
                        white-space:nowrap;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        font-size: 11px;
                        font-weight: 400;
                        color: #333333;
                        div{
                            display: inline-block;
                            width: 40px;
                        }
                        &:nth-child(even) {
                            background: #F5F5F5;
                        }
                    }
                    .header{
                        background: #FFFFFF;
                        box-shadow: 1px 0px 1px 0px rgba(0,0,0,0.1);
                        font-size: 11px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
        }
    }
}
.careerDark{
    min-height: 100vh;
    background-color: #191919;
    .top{
        .select{
            p{
                color: #a6a6a6;
            }
        }
    }
    .teamData{
        .table{
            .tbody{
                .left{
                    .item{
                        border-color: #191919;
                        color: #d3d3d3;
                        &:nth-child(even) {
                            background-color: #232323;
                        }
                    }
                    .header{
                        background-color: #1d1d1d;
                    }
                }
                .right{
                    .item{
                        color: #d3d3d3;
                        &:nth-child(even) {
                            background: #232323;
                        }
                    }
                    .header{
                        background: #1d1d1d;
                        color: #a6a6a6;
                    }
                }
            }
        }
    }
}
</style>
